import type { components } from '@/shared/api/autogen/schema';

type AdminDeliveryStatus = components['schemas']['AdminDeliveryStatus'];

/**
 * 管理系ステータスラベル（管理画面用）
 */
export const ADMIN_DELIVERY_STATUS_LABELS: Record<AdminDeliveryStatus, string> = {
    applied: '申し込み済み',
    airport_counter_received: '空港カウンター預かり',
    in_transit: '配送中',
    hotel_arrived: 'ホテル到着',
    hotel_checked: 'ホテル検品済み',
    delivery_completed: 'ユーザー受け取り完了',
    cancelled: 'キャンセル',
    delayed: '遅延・要確認',
};
